/* Packages */
import React, { useEffect, useState } from 'react';
import { v1 as uuidv1 } from 'uuid';

/* Common */
import { Collapse } from '~/components/common';

/* Utilities */
import { trans } from '~/utilities';

export default function OptionSelectList({ filter, updateFilters }) {
    const [optiongGroups, setOptionGroups] =  useState([]);

    useEffect(() => {
        groupOptions();
    }, [filter]);

    const groupOptions = () => {
        const newGroups = getDefaultFilters();

        filter.choices.forEach((choice) => {
            if (choice.key === 'Android Auto' || choice.key === 'Apple Carplay' || choice.key === 'Bluetooth telefoon' || choice.key === 'DAB radio' || choice.key === 'Draadloos opladen mobiele telefoon' ||
                choice.key === 'Radio' || choice.key === 'Radio met multimedia' || choice.key === 'Smartphone-integratie' || choice.key === 'Spraakbediening' || choice.key === 'Telefoonvoorbereiding met bluetooth') {
                newGroups[0].choices.push(choice);
            } else if (choice.key === 'Airconditioning' || choice.key === 'Climate control' || choice.key === 'Elektrisch verstelbare stoelen' || choice.key === 'Elektrische ramen' || choice.key === 'Getint glas' ||
                choice.key === 'Hoge instap' || choice.key === 'ISOFIX aansluiting' || choice.key === 'Skiluik' || choice.key === 'Stoelverwarming' || choice.key === 'Stuurbekrachtiging' ||
                choice.key === 'Stuurwielverwarming' || choice.key === 'Verstelbaar stuurwiel' || choice.key === 'Warmtewerend glas') {
                newGroups[1].choices.push(choice);
            } else if (choice.key === 'Dakrails' || choice.key === 'Elektrisch bedienbaar cabrioletkap' || choice.key === 'Elektrisch bedienbaar schuifdak' || choice.key === 'Elektrisch inklapbare buitenspiegels' || choice.key === 'Glazen dak' ||
                choice.key === 'Lichtmetalen velgen' || choice.key === 'Panoramadak' || choice.key === 'Spoiler' || choice.key === 'Sportonderstel' || choice.key === 'Trekhaak' ||
                choice.key === 'Verwarmde buitenspiegels' || choice.key === 'Vierwielaandrijving') {
                newGroups[2].choices.push(choice);
            } else if (choice.key === 'Achteruitrijcamera' || choice.key === 'Adaptieve cruise control' || choice.key === 'Bandenspanningscontrole' || choice.key === 'Boordcomputer' || choice.key === 'Buitenspiegels elektrisch verstelbaar' ||
                choice.key === 'Cruise control' || choice.key === 'Dodehoek detector' || choice.key === 'Head-up display' || choice.key === 'Hill hold-functie' || choice.key === 'Keyless entry' ||
                choice.key === 'Keyless start' || choice.key === 'Navigatiesysteem' || choice.key === 'Parkeer-assistent' || choice.key === 'Parkeersensoren' || choice.key === 'Range extender' ||
                choice.key === 'Regensensor' || choice.key === 'Rijstrooksensor' || choice.key === 'Start/stop systeem' || choice.key === 'Startonderbreker' || choice.key === 'Stuurwiel multifunctioneel' ||
                choice.key === 'Verkeersbordherkenning' || choice.key === 'Vermoeidheidsherkenning' || choice.key === 'Voorruitverwarming') {
                newGroups[3].choices.push(choice);
            } else if (choice.key === 'Bochtenverlichting' || choice.key === 'Dagrijverlichting' || choice.key === 'LED verlichting' || choice.key === 'Xenon verlichting') {
                newGroups[4].choices.push(choice);
            } else {
                newGroups[5].choices.push(choice);
            }
        });

        setOptionGroups(newGroups);
    }

    const getDefaultFilters = () => {
        return [
            {
                label: trans(`webstores_voertuigen_voorraad.filter.option_filter.groups.audio`),
                choices: []
            },
            {
                label: trans(`webstores_voertuigen_voorraad.filter.option_filter.groups.interior`),
                choices: []
            },
            {
                label: trans(`webstores_voertuigen_voorraad.filter.option_filter.groups.exterior`),
                choices: []
            },
            {
                label: trans(`webstores_voertuigen_voorraad.filter.option_filter.groups.security`),
                choices: []
            },
            {
                label: trans(`webstores_voertuigen_voorraad.filter.option_filter.groups.lighting`),
                choices: []
            },
            {
                label: trans(`webstores_voertuigen_voorraad.filter.option_filter.groups.other`),
                choices: []
            }
        ];
    }

    const setChoice = (item) => {
        const updatedFilter = filter;

        updatedFilter.choices.forEach((choice) => {
            if (choice.key === item.key) choice.active = !choice.active;
        });

        updateFilters([updatedFilter]);
    }

    const hasActiveChoice = (group) => {
        let hasActive = false;

        group.choices.forEach((choice) => {
            if (choice.active) {
                hasActive = true;
            }
        });

        return hasActive;
    }

    return (
        <>
            {optiongGroups.map((group, groupIndex) => (
                <>
                    {group.choices.length > 0 && (
                        <Collapse trigger={group.label} open={hasActiveChoice(group)} classes="btn--collapse--small">
                            <ul className={`list-group list-group--options ${groupIndex !== optiongGroups.length - 1 ? 'mt-n2 mt-lg-0 mb-2 mb-lg-4' : ''}`}>
                                {group.choices.map((choice, choiceIndex) => {
                                    const id = uuidv1();

                                    return (
                                        <li key={choiceIndex} className="list-group-item">
                                            <div className="custom-control custom-checkbox position-relative">
                                                <input
                                                    id={id}
                                                    name={`${filter.filterKey}[]`}
                                                    className="custom-control-input"
                                                    type="checkbox"
                                                    value={choice.name}
                                                    checked={choice.active}
                                                    onChange={() => setChoice(choice)}
                                                />
                                                <label className="custom-control-label d-flex align-items-center" htmlFor={id}>
                                                    {choice.name}
                                                </label>
                                            </div>
                                        </li>
                                    );
                                })}
                            </ul>
                        </Collapse>
                    )}
                </>
            ))}
        </>
    );
}
